import React from "react";

export const plants = [
  {
    CN: "蘇州廠",
    EN: "Suzhou",
    url: "https://ffsz.satdg.com:4433/pds",
    "latitude": 33.63611,
    "longitude": 116.97889,
  },
  {
    CN: "中山廠",
    EN: "Zhongshan",
    url: "https://ffzs.satdg.com:4433/pds",
    "latitude": 22.52306,
    "longitude": 113.37912,
  },
  {
    CN: "福州廠",
    EN: "Fuzhou",
    url: "https://fffz.satdg.com:4433/pds",
    "latitude": 26.06139,
    "longitude": 119.30611,
  },
  {
    CN: "重慶廠",
    EN: "Chongqing",
    url: "https://ffcq.satdg.com:4433/pds",
    "latitude": 29.56026,
    "longitude": 106.55771,
  },
  {
    CN: "越南廠",
    EN: "Vietnam",
    url: "https://vn.sync.satdg.com:4433/pds",
    "latitude": 10.82302,
    "longitude": 106.62965,
  },
  {
    CN: "泰國廠",
    EN: "Thailand",
    url: "https://th.sync.satdg.com:4433/pds",
    "latitude": 13.75398,
    "longitude": 100.50144,
  },
  {
    CN: "信鋐",
    EN: "SynX",
    url: "https://pds.ty.sat.com.tw",
    "longitude": 121.52639,
    "latitude": 25.05306,
  },
  {
    CN: "鴻嘉駿",
    EN: "Hong Jiajun",
    url: "https://hjj.satdg.com:4433/dashboard",
    "latitude": 27.52731,
    "longitude": 120.47258,
  },
  {
    CN: "冠皇",
    EN: "DGKH",
    url: "https://dgkh.satdg.com:4433/pds/dashboard",
    "latitude": 27.52731,
    "longitude": 120.47258,
  },
  {
    CN: "敬得",
    EN: "GateTech",
    url: "https://pds.gt.sat.com.tw/",
    "longitude": 121.52639,
    "latitude": 25.05306,
  },
];

const Footer = ({ set_s_hoverPlant }) => {
  return (
    <section
      className={`
        fixed bottom-0 left-0
      w-[99%] h-[100px]
      flex justify-center items-center
      gap-[15px] pl-3 pr-3
      `}
    >
      {plants.map((plant, index) => (
        <div
          key={index}
          onMouseEnter={() => {
            set_s_hoverPlant(plant.CN);
          }}
          onMouseLeave={() => {
            set_s_hoverPlant("");
          }}
          className="card"
          onClick={() => {
            window.open(plant.url, "_blank");
          }}
        >
          <div className="title">{plant.CN}</div>
          <div className="subtitle">{plant.EN}</div>
        </div>
      ))}
    </section>
  );
};

export default Footer;
